import { useTranslation } from "react-i18next";

import { FormDialog } from "../../../../form-dialog/FormDialog";
import { ClaimFormFields } from "../claim-form-fields/ClaimFormFields";
import { useClaimCreation } from "./hooks/useClaimCreation";

interface Props {
  clientId: string;
  onClose: () => void;
}

export function ClaimCreationDialog({ clientId, onClose }: Props) {
  const { t } = useTranslation();
  const { formik, options } = useClaimCreation(clientId, onClose);

  return (
    <FormDialog title={t("claims.create.dialogTitle")} onClose={onClose} formik={formik} submitLabel={t("common.save")}>
      <ClaimFormFields formik={formik} options={options} clientId={clientId} />
    </FormDialog>
  );
}
